import React, { FC } from 'react';

const IconArrowDown: FC = () => {
  return (
    <svg
      className="inline"
      transform="rotate(-180)"
      width="12"
      height="9"
      viewBox="0 0 12 9"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 0.939453L5.707 5.23245L1.414 0.939453L0 2.35345L5.707 8.06045L11.414 2.35345L10 0.939453Z" />
    </svg>
  );
};

export default IconArrowDown;
